import api from './api';

export const getDashboardStats = () => api.get('dashboard/stats');
export const getRecentVehicles = () => api.get('vehicles?limit=5');
export const getRecentLicenses = () => api.get('licenses?limit=5');
export const getUpcomingBirthdays = (days = 5) => api.get(`employees/upcoming-birthdays?days=${days}`);

export const getUpcomingLeaves = (month = null, year = null) => {
  const today = new Date();
  const currentMonth = month || today.getMonth() + 1;
  const currentYear = year || today.getFullYear();
  
  console.log(`Fetching leaves for ${currentMonth}/${currentYear}`);
  
  // First, get all leaves
  return api.get('leaves/all')
    .then(response => {
      console.log('Raw leaves data:', response.data);
      
      // Handle different possible response structures
      const allLeaves = Array.isArray(response.data) ? 
        response.data : 
        (response.data?.data || response.data?.leaves || []);
      
      console.log('Processed leaves array:', allLeaves);
      
      // Filter leaves for the specified month and year
      const filteredLeaves = allLeaves.filter(leave => {
        if (!leave.start_date) return false;
        
        try {
          const startDate = new Date(leave.start_date);
          const endDate = new Date(leave.end_date || leave.start_date);
          
          // Check if the leave overlaps with the target month/year
          const targetDate = new Date(currentYear, currentMonth - 1, 1);
          const nextMonth = new Date(currentYear, currentMonth, 1);
          
          // Only include future or current leaves
          const isUpcoming = endDate >= new Date(today.toISOString().split('T')[0]);
          
          // Check if leave is in the target month
          const isInTargetMonth = 
            (startDate < nextMonth && endDate >= targetDate) || // Overlaps with target month
            (startDate.getMonth() === currentMonth - 1 && startDate.getFullYear() === currentYear) || // Starts in target month
            (endDate.getMonth() === currentMonth - 1 && endDate.getFullYear() === currentYear); // Ends in target month
          
          return isUpcoming && isInTargetMonth;
        } catch (error) {
          console.error('Error processing leave:', leave, error);
          return false;
        }
      });
      
      console.log('Filtered leaves:', filteredLeaves);
      
      // Sort by start date
      filteredLeaves.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
      
      return { data: filteredLeaves };
    })
    .catch(error => {
      console.error('Error fetching leaves:', error);
      return { data: [] }; // Return empty array on error
    });
};

export const getUpcomingAppraisals = (days = 5) => {
  return api.get(`appraisals/upcoming?days=${days}`);
};

export const getActiveEmployeesWithNoticePeriod = () => {
  return api.get('employees/active-with-notice-period');
};
